const state = {
  showingInfo: false,
  addingMembers: false,
  defaultGroupImage:
    "https://firebasestorage.googleapis.com/v0/b/courselnk.appspot.com/o/originalChat.png?alt=media&token=b2ab8f4a-83f7-44cc-960b-f7590a5a162c",
};

const mutations = {
  setShowingInfo(state, isShowing) {
    state.showingInfo = isShowing;
  },
  setAddingMembers(state, isAdding) {
    state.addingMembers = isAdding;
  },
};

const actions = {
  getGroupType(_, data) {
    var user = data.user;
    var group_id = data.groupId;

    for (const index in user.courses) {
      if (user.courses[index].id === group_id) {
        return "courses";
      }
    }
    for (const index in user.faculties) {
      if (user.faculties[index].id === group_id) {
        return "faculties";
      }
    }
    for (const index in user.groups) {
      if (user.groups[index].id === group_id) {
        return "groups";
      }
    }

    for (const index in user.directMessages) {
      if (user.directMessages[index].id === group_id) {
        return "directMessages";
      }
    }
  },

  getGroupName(_, group) {
    if (!group) {
      return "";
    }
    return group.name;
  },

  getGroupsFromType(_, data) {
    var user = data.user;
    var group_id = data.groupId;

    for (const index in user.courses) {
      if (user.courses[index].id === group_id) {
        return user.courses;
      }
    }
    for (const index in user.faculties) {
      if (user.faculties[index].id === group_id) {
        return user.faculties;
      }
    }
    for (const index in user.groups) {
      if (user.groups[index].id === group_id) {
        return user.groups;
      }
    }
    for (const index in user.directMessages) {
      if (user.directMessages[index].id === group_id) {
        return user.directMessages;
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
